import { render, staticRenderFns } from "./TextLabel.vue?vue&type=template&id=53d8b5fc&scoped=true"
var script = {}
import style0 from "./TextLabel.vue?vue&type=style&index=0&id=53d8b5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8b5fc",
  null
  
)

export default component.exports